import { getUserKey } from "utils/getUserKey";

export interface RecentlyVisitedOrg {
    lastVisit?: string;
    organizationId: string;
    name: string;
    logoUrl?: string;
}

interface OrgToLocalStorageArgs {
    organizationId: string;
    name: string;
    logoUrl?: string;
}

export function getRecentlyVisitedOrgs(): RecentlyVisitedOrg[] {
    // eject if there is no localStorage
    if (!localStorage) {
        return [];
    }

    const storageKey = `user-${getUserKey()}-recent-orgs`;
    const storedApps: RecentlyVisitedOrg[] = localStorage.hasOwnProperty(storageKey)
        ? JSON.parse(localStorage[storageKey])
        : [];

    return storedApps;
}

export function setRecentlyVisitedOrgs(args: OrgToLocalStorageArgs): void {
    // eject if there is no localStorage
    if (!localStorage) {
        return;
    }

    const storedOrgs = getRecentlyVisitedOrgs();
    const storageKey = `user-${getUserKey()}-recent-orgs`;
    const recentlyVisitedOrg: RecentlyVisitedOrg = {
        lastVisit: Date.now().toString(),
        organizationId: args.organizationId,
        name: args.name,
        logoUrl: args.logoUrl
    };

    let mutableOrgs: RecentlyVisitedOrg[] = storedOrgs.filter((storedOrg: RecentlyVisitedOrg) => {
        return storedOrg.organizationId !== args.organizationId;
    });

    mutableOrgs = [].concat(recentlyVisitedOrg, mutableOrgs).slice(0, 5);
    localStorage.setItem(storageKey, JSON.stringify(mutableOrgs));
}